import { connect } from 'react-redux';
import View from './FinancialAccountsWorkflowView';
import { WORKFLOW_ID, VIEWS } from './FinancialAccountsWorkflowConstants';
import {
  reloadAdvizrApplication,
  endOfWorkflowsRedirectTo,
} from '../AdvWorkflow/AdvWorkflowHelpers';
import { setCurrentView } from '../../MobileNetworthTransactions/MobileNetWorthTransactionsActions';
import withResponsiveness from '../../CommonComponents/withResponsiveness';

const mapStateToProps = () => ({
  workflowId: WORKFLOW_ID,
});

const mapDispatchToProps = dispatch => ({
  outputFunction: (clientId, isMobile) => (_, canGoToAccounts) => {
    const { ADV } = window;
    reloadAdvizrApplication(true, false, () => {
      if (canGoToAccounts) {
        if (isMobile) {
          ADV.util.Router.go2('Transactions', { clientId, accountId: 0 });
          dispatch(setCurrentView(VIEWS.NETWORTH));
        } else {
          ADV.util.Router.go2('ProfileAccounts', {
            clientId,
          });
        }
        return;
      }
      const currentClient = ADV.util.getCurrentClient(ADV.data);
      const outputRoute = currentClient.ComponentName;
      const params = {
        clientId,
      };
      endOfWorkflowsRedirectTo(outputRoute, params);
    });
  },
});

export default withResponsiveness(connect(mapStateToProps, mapDispatchToProps)(View));
